module.exports = __webpack_public_path__ + "static/media/storage_package.1aa9400d.jpg";